export default __webpack_public_path__ + "static/media/green.8eca06a0.png";